module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Gc-Ha-Ia.978c7971.png";